import React from 'react';
import Container from '@material-ui/core/Container';
import {makeStyles} from '@material-ui/core/styles';

export const styles = makeStyles({
    contentContainer: {
        maxWidth: '100%',
        height: '100%',
        margin: 'auto',
        padding: 0,
        textAlign: 'center',
    }
});

const ErrorView = () => {
    const classes = styles();
    return (
        <Container className={classes.contentContainer}>
            <div>
                <h1>Data Not Found</h1>
            </div>
        </Container>
    )
}

export default ErrorView;